var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",{"type":"text/css"},"\n   \n    .fil0 {fill:#000000}\n   \n  ")),React.createElement("g",{"key":1},React.createElement("path",{"className":"fil0","d":"M12 304l292 -292c17,-16 43,-16 59,0 16,16 16,42 0,59l-263 263 263 263c16,16 16,43 0,59 -16,16 -42,16 -59,0l-292 -293c-16,-16 -16,-42 0,-59z"}))]);
}

Arrow.defaultProps = {"height":"300px","width":"300px","fill":"#000000","xmlSpace":"preserve","version":"1.1","style":{"shapeRendering":"geometricPrecision","textRendering":"geometricPrecision","imageRendering":"optimizeQuality"},"viewBox":"0 0 375 668","x":"0px","y":"0px","fillRule":"evenodd","clipRule":"evenodd"};

module.exports = Arrow;

Arrow.default = Arrow;
